import $ from 'jquery';
import getGaClientId from '../common/get_ga_client_id';

export const initialiseMechanicApplicationPage = function () {
  const heardAboutUsSelect = $('select#heard-about-us-options');

  if (heardAboutUsSelect.length) {
    heardAboutUsSelect.on('change', function (e) {
      var selected_text = $(e.target).find('option:selected').html();
      if (/\Aother\z/i.test(selected_text)) {
        $('input#heard-about-us-text').slideDown(200);
      } else {
        $('input#heard-about-us-text').hide();
      }
    });
  }


  function hideOtherFields(checkboxes) {
    checkboxes.closest('.js-mechanic-application-certification-checkbox')
      .next('.js-mechanic-application-certification-other')
      .addClass('hidden').find('strong.error').remove();
  }

  function updateInactiveState(noneCheckbox, itemCheckboxes) {
    const noneWrapper = noneCheckbox.closest('.checkbox');
    const itemWrappers = itemCheckboxes.closest('.checkbox');
    const noneChecked = noneCheckbox.is(':checked');
    const anyItemChecked = itemCheckboxes.is(':checked');

    noneWrapper.toggleClass('is-inactive', anyItemChecked);
    itemWrappers.toggleClass('is-inactive', noneChecked);
  }

  function setupNoneOptionMutualExclusivity(noneCheckbox, itemCheckboxes) {
    noneCheckbox.on('change', function () {
      if ($(this).is(':checked')) {
        itemCheckboxes.prop('checked', false);
        hideOtherFields(itemCheckboxes);
      }
      updateInactiveState(noneCheckbox, itemCheckboxes);
    });

    itemCheckboxes.on('change', function () {
      if ($(this).is(':checked')) {
        noneCheckbox.prop('checked', false);
      }
      updateInactiveState(noneCheckbox, itemCheckboxes);
    });
  }

  const noCertificationsCheckbox = $('.js-no-certifications-checkbox input[type="checkbox"]');
  const certificationCheckboxes = noCertificationsCheckbox.closest('.js-no-certifications-checkbox')
    .nextUntil('h5')
    .filter('.js-mechanic-application-certification-checkbox')
    .find('input[type="checkbox"]');

  setupNoneOptionMutualExclusivity(noCertificationsCheckbox, certificationCheckboxes);

  const noMembershipsCheckbox = $('.js-no-memberships-checkbox input[type="checkbox"]');
  const membershipCheckboxes = noMembershipsCheckbox.closest('.js-no-memberships-checkbox')
    .nextAll('.js-mechanic-application-certification-checkbox')
    .find('input[type="checkbox"]');

  setupNoneOptionMutualExclusivity(noMembershipsCheckbox, membershipCheckboxes);

  // Handle "Other" certification fields
  $('.js-mechanic-application-certification-checkbox input[type="checkbox"]').on('change', function (event) {
    const checkbox = $(event.target);
    const other_field = checkbox.closest('.js-mechanic-application-certification-checkbox').next();

    if (other_field.hasClass('js-mechanic-application-certification-other')) {
      if (checkbox.is(':checked')) {
        other_field.removeClass('hidden');
      } else {
        other_field.addClass('hidden');
        other_field.find('strong.error').remove();
      }
    }
  });

  $('.js-other-specialist-service-toggle').on('change', function () {
    const otherField = $('.js-other-specialist-service-field');
    if ($(this).is(':checked')) {
      otherField.removeClass('hidden');
    } else {
      otherField.addClass('hidden');
      otherField.find('input').val('');
      otherField.find('strong.error').remove();
    }
  });

  function updatePremisesAddressVisibility() {
    const premisesSection = $('.js-premises-address');
    const providerType = $('input[name="mechanic_application[provider_type]"]:checked').val();
    const customerDropOff = $('#mechanic_application_customer_drop_off').is(':checked');
    const collectionAndDelivery = $('#mechanic_application_collection_and_delivery').is(':checked');

    const requiresPremises =
      providerType === 'garage' ||
      providerType === 'mobile_mechanic_and_garage' ||
      customerDropOff ||
      collectionAndDelivery;

    if (requiresPremises) {
      premisesSection.slideDown(200);
      $('.js-travel-postcode').hide();
      $('.js-travel-premises').show();
    } else {
      premisesSection.slideUp(200);
      $('.js-travel-postcode').show();
      $('.js-travel-premises').hide();
    }
  }

  $('input[name="mechanic_application[provider_type]"]').on('change', updatePremisesAddressVisibility);
  $('#mechanic_application_customer_drop_off, #mechanic_application_collection_and_delivery').on('change', updatePremisesAddressVisibility);

  const form = $('#mechanic_application_form');
  const attachGaTrackingInput = function (gaClientId) {
    if (!gaClientId) {
      return false;
    }

    let input = form.find('input[name="mechanic_application[ga_client_id]"]');
    if (!input.length) {
      input = $('<input>', { type: 'hidden', name: 'mechanic_application[ga_client_id]' });
      form.prepend(input);
    }

    input.val(gaClientId);
    return true;
  };

  let gaTrackingAttempts = 0;
  const tryAttachGaTrackingInput = function () {
    if (attachGaTrackingInput(getGaClientId()) || gaTrackingAttempts >= 10) {
      return;
    }

    gaTrackingAttempts += 1;
    setTimeout(tryAttachGaTrackingInput, 250);
  };

  tryAttachGaTrackingInput();

  const button = form.find('input[type="submit"]');
  if (button.length) {
    const text = button.data('disable-with');
    const originalText = button.val();

    button.click(() => {
      button.val(text);
    });

    // Reset button text when form has errors (using MutationObserver to detect error class)
    const observer = new MutationObserver(() => {
      if (form.hasClass('form-has-errors')) {
        button.val(originalText);
      }
    });

    observer.observe(form[0], { attributes: true, attributeFilter: ['class'] });
  }
};

$(initialiseMechanicApplicationPage);
